import { render, staticRenderFns } from "./City.vue?vue&type=template&id=563a62f1&scoped=true&"
import script from "./City.vue?vue&type=script&lang=js&"
export * from "./City.vue?vue&type=script&lang=js&"
import style0 from "./City.vue?vue&type=style&index=0&id=563a62f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a62f1",
  null
  
)

export default component.exports